import React from 'react';
import { SortableContainer } from 'react-sortable-hoc';
import DraggableBlock from './DraggableBlock';

const SortableList = SortableContainer(({ items, offset = 0 }) => {
	const generateKey = React.useMemo(() => Math.random().toString(36).substr(2, 9), [items, offset]);
	return (
		<div>
			{ items.map((el, index) => (<DraggableBlock
				key={`item-${generateKey + index}`}
				index={offset + index}
				value={el}
			/>
			))
			}
		</div>
	);
});

export default SortableList;
